import React, { useState, useRef, useEffect } from "react";
import { Modal, TextField, Button, IconButton, InputAdornment, Avatar } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./Header.css";
import SaveButton from "./Common_Components/SaveButton";
import ResetButton from "./Common_Components/ResetButton";
import CustomInputField from "./Common_Components/CustomInputField";
import { Toast } from "./Common_Components/Toast";
import axiosInstance from "./axios/axios";

const Header = () => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [showPassword, setShowPassword] = useState({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
    });
    const [currentpasswd, setCurrentPasswd] = useState('')
    const [newpasswd, setNewpasswd] = useState('')
    const [confirmpasswd, setConfirmpasswd] = useState('')

    const dropdownRef = useRef(null);
    //getting user data from local storage
    const userdata = JSON.parse(localStorage.getItem('User_Details')) || {};
    // Extract the first name from the user's full name
    const firstName = Object.keys(userdata).length > 0 ? userdata?.UD_Name.split(" ")[0] : '';

    const toggleDropdown = () => setShowDropdown(!showDropdown);
    const openChangePasswordModal = () => {
        setShowDropdown(false);
        setShowChangePasswordModal(true);
    };
    const closeChangePasswordModal = () => setShowChangePasswordModal(false);

    const handleTogglePassword = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    // Close the dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    //change password function
    const HandleChangePassword = async () => {
        if (!currentpasswd) {
            Toast.warning("Please enter current password")
        } else if (newpasswd !== confirmpasswd) {
            Toast.warning("New Passwoed and confirm password must be same")
        } else {
            const request = {
                userId: userdata?.UD_Id,
                oldPassword: currentpasswd,
                newPassword: newpasswd
            }

            const response = await axiosInstance.post('/users/changePassword', request)
            const { success, message } = response.data
            if (success === true) {
                closeChangePasswordModal()
                Toast.success(message)
            } else {
                Toast.error(message)
            }
        }

    }
    return (
        <>
            <header className="header">
                <div className="header-left">
                    <h1 className="header-title">MLM</h1>
                </div>
                <div className="header-right">
                    <div className="user-profile" ref={dropdownRef}>
                        <Avatar
                            className="profile-icon"
                            onClick={toggleDropdown}
                            sx={{ cursor: "pointer", backgroundColor: "white", color: '#693F98' }}
                        >
                            {firstName.charAt(0)}
                        </Avatar>
                        {showDropdown && (
                            <div className="profile-dropdown">
                                <p><strong>Name:</strong> {userdata?.UD_Name}</p>
                                <p><strong>Email:</strong> {userdata?.UD_Email}</p>
                                <p><strong>Address:</strong> {userdata?.UD_Address}</p>
                                <p><strong>Username:</strong> {userdata?.UD_userName}</p>
                                <Button
                                    variant="contained"
                                    sx={{ backgroundColor: "#693F98" }}
                                    onClick={openChangePasswordModal}
                                >
                                    Change Password
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {/* Change Password Modal */}
            <Modal
                open={showChangePasswordModal}
                onClose={closeChangePasswordModal}
                className="modal-container"
            >
                <div className="modal-content">
                    <h2>Change Password</h2>
                    <CustomInputField
                        label="Current Password"
                        fullWidth
                        type={showPassword.currentPassword ? "text" : "password"}
                        value={currentpasswd}
                        onChange={(e) => setCurrentPasswd(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    onClick={() => handleTogglePassword("currentPassword")}
                                    edge="end"
                                >
                                    {showPassword.currentPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            ),
                        }}
                    />

                    <CustomInputField
                        label="New Password"
                        fullWidth
                        type={showPassword.newPassword ? "text" : "password"}
                        value={newpasswd}
                        onChange={(e) => setNewpasswd(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    onClick={() => handleTogglePassword("newPassword")}
                                    edge="end"
                                >
                                    {showPassword.newPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            ),
                        }}
                    />
                    <CustomInputField
                        label="Confirm Password"
                        fullWidth
                        type={showPassword.confirmPassword ? "text" : "password"}
                        value={confirmpasswd}
                        onChange={(e) => setConfirmpasswd(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    onClick={() => handleTogglePassword("confirmPassword")}
                                    edge="end"
                                >
                                    {showPassword.confirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            ),
                        }}
                    />
                    <div className="modal-actions">
                        <SaveButton onClick={HandleChangePassword} label="Save" />
                        <ResetButton onClick={closeChangePasswordModal} label="Cancel" />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Header;
